import { getConstant } from '../utils';

export const getDeterminantTypes = getConstant('GET_DETERMINANT_TYPES');
export const clearDeterminantTypes = getConstant('CLEAR_DETERMINANT_TYPES');